import React from 'react';
import { Container, Form } from 'react-bootstrap';
import '../assets/css/Cogen.css';
import { Header, Footer } from './Container';

function Review() {
    return (
        <Container fluid="true" className="p-0">
            <Header type="member" />
            <Container>
                <div className="review-wrapper">
                    <h4 className="review-heading">Write a review</h4> <br /> <br /> 
                    <p className="review-sub-headings">Rate</p><br /><br />
                    <p className="review-sub-headings">I highly recommend this</p>
                    <Form.Check size="lg" custom inline type="switch" id="custom-switch" label=" " />
                    <br /><br />
                    <p className="review-sub-headings">Review Title</p>
                    <Form.Control type="text" placeholder="Review Title" /><br /><br />
                    <p className="review-sub-headings">What are you thoughts and experiences?</p>
                    <Form.Control as="textarea" rows={4} placeholder="Comments" /><br /><br />
                    <button className="btn-submit-review">Submit your Review</button>
                </div>
            </Container>
            <Footer />
        </Container>
    )
};
export default Review;
